import { canUseDOM } from '@/app/common/utils/canUseDOM';

export type RatingInterval = {
  interval: {
    min: number;
    max: number;
  };
  name: string;
  translationKey: string;
};

export const reviewsConfig = {
  trustYou: [
    {
      interval: {
        min: 87,
        max: 100,
      },
      name: 'excellent',
      translationKey: 'vacation.common.rating.excellent',
    },
    {
      interval: {
        min: 81,
        max: 86,
      },
      name: 'verygood',
      translationKey: 'vacation.common.rating.verygood',
    },
    {
      interval: {
        min: 75,
        max: 80,
      },
      name: 'good',
      translationKey: 'vacation.common.rating.good',
    },
    {
      interval: {
        min: 60,
        max: 74,
      },
      name: 'fair',
      translationKey: 'vacation.common.rating.fair',
    },
    {
      interval: {
        min: 0,
        max: 59,
      },
      name: 'poor',
      translationKey: 'vacation.common.rating.poor',
    },
  ],
};

export function getInterval(rating: number): RatingInterval | undefined {
  return reviewsConfig.trustYou.find(({ interval }) => rating >= interval.min && rating <= interval.max);
}

export const defaultTrustYouColors: Dynamic<string> = {
  poor: '#d9d4ca',
  fair: '#f8ce72',
  good: '#bfcc4e',
  verygood: '#a0ca3f',
  excellent: '#7cb342',
};

export const getColor = (scoreValue: number | undefined, colors?: Dynamic<string>) => {
  if (!scoreValue) return defaultTrustYouColors.good;
  const trustYouColors = colors || defaultTrustYouColors;
  const rating = getInterval(scoreValue);

  return rating ? trustYouColors[rating.name] : trustYouColors.good;
};

export type UserInteraction = {
  action: string;
  label: string;
  category: string;
};

export function trackReviewUserInteraction(
  trackTypes: Dynamic<UserInteraction>,
  type: keyof typeof trackTypes,
  label?: string
): void {
  if (!canUseDOM) {
    return;
  }
  const { action, label: typeLabel, category } = trackTypes[type];
  window.platformData?.push({
    event: 'userInteraction',
    user: {
      interaction: {
        category,
        action,
        label: label || typeLabel,
        n: 0,
      },
    },
  });
}

export function decorateRatingScore(rating: number | undefined): string {
  if (!rating) return '-';
  const decimalRating = rating / 10;
  return decimalRating === 10 ? '10' : decimalRating.toFixed(1);
}
